import React from 'react';
import { Link } from 'react-router-dom';

const StickyMobileCTA: React.FC = () => (
  <div
    className="sticky-mobile-cta"
    style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      height: '56px',
      backgroundColor: 'var(--color-brand)',
      zIndex: 50,
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Link
      to="/appointment"
      style={{
        color: 'white',
        fontWeight: 600,
        fontSize: '1rem',
        textDecoration: 'none',
        letterSpacing: '0.02em',
      }}
    >
      Termin buchen
    </Link>
  </div>
);

export default StickyMobileCTA;
